import { application } from "./application"
import AddressAutocompleteController from "./address_autocomplete_controller"
import DropdownController from "./dropdown_controller"
import AvatarPreviewController from "./avatar_preview_controller"
import ToastController from "./toast_controller"
import ModalController from "./modal_controller"
import ModalTriggerController from "./modal_trigger_controller"
import MobileNavController from "./mobile_nav_controller"
import RotatingTextController from "./rotating_text_controller"
import TabsController from "./tabs_controller"
import HoverMessageController from "./hover_message_controller"
import DateModeController from "./date_mode_controller"
import PlaceAutocompleteController from "./place_autocomplete_controller"
import MapController from "./map_controller"
import ThemeController from "./theme_controller"
import FormWizardController from "./form_wizard_controller"
import LocationModeController from "./location_mode_controller"
import ProposedLocationController from "./proposed_location_controller"
import ClipboardController from "./clipboard_controller"
import TimeOfDayController from "./time_of_day_controller"
import LocationCostsController from "./location_costs_controller"

application.register("address-autocomplete", AddressAutocompleteController)
application.register("dropdown", DropdownController)
application.register("avatar-preview", AvatarPreviewController)
application.register("toast", ToastController)
application.register("modal", ModalController)
application.register("modal-trigger", ModalTriggerController)
application.register("mobile-nav", MobileNavController)
application.register("rotating-text", RotatingTextController)
application.register("tabs", TabsController)
application.register("hover-message", HoverMessageController)
application.register("date-mode", DateModeController)
application.register("place-autocomplete", PlaceAutocompleteController)
application.register("map", MapController)
application.register("theme", ThemeController)
application.register("form-wizard", FormWizardController)
application.register("location-mode", LocationModeController)
application.register("proposed-location", ProposedLocationController)
application.register("clipboard", ClipboardController)
application.register("time-of-day", TimeOfDayController)
application.register("location-costs", LocationCostsController)
